import styled from 'styled-components'

import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'

export const HeroMain = styled.section`
  position: relative;
  max-height: 550px;
  ${mq.tabletL} {
    max-height: 100vh;
  }

  overflow: hidden;
  background-color: ${colors.charcoal};
  color: ${colors.white};

  > div:not(${''}) {
    position: relative;
    z-index: 2;
  }
`

export const HeroBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
  }
`

export const HeroVideo = styled.video`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
`

export const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(
      90deg,
      rgba(0, 38, 38, 0.82) 0%,
      rgba(0, 38, 38, 0.58) 36%,
      rgba(0, 20, 20, 0.1) 70%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.08) 0%,
      rgba(0, 0, 0, 0.16) 100%
    );
`

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  ${clamp('padding-top', 40, 68)}
  ${clamp('padding-bottom', 40, 72)}
`

export const HeroTitle = styled.h1`
  margin: 0;
  max-width: 90rem;
  color: inherit;
  
  p {
    ${clamp('font-size', 48, 92)};
    font-family: Signifier;
    strong {
      font-family: National2;
      font-weight: 900;
    }
  }

  ${mq.tabletL} {
    max-width: 120rem;
  }
`

export const HeroList = styled.ul`
  flex: 1;
  width: fit-content;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0;
  padding: clamp(4rem, 7vh, 9rem) 0;
  list-style: none;

  ${clamp('gap', 28, 58)}
`

export const HeroListItem = styled.li`
  margin: 0;
  padding: 0;
`

const heroNavigationStyles = `
  position: relative;
  display: inline-block;
  border: 0;
  background: transparent;
  ${clamp('font-size', 18, 32)}
  font-weight: 400;
  transform: scale(1);
  transform-origin: left center;
  transition:
    transform 250ms ease,
    font-weight 250ms ease;
  cursor: pointer;

  strong {
    font-weight: 500;
  }

  em {
    font-style: italic;
  }

  &:hover {
    transform: scale(1.2);
    strong {
      font-weight: 700;
    }
  }

  &:focus-visible {
    outline: 0.2rem solid currentColor;
    outline-offset: 0.8rem;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:hover {
      transform: none;
    }
  }
`

export const HeroButton = styled.button`
  ${heroNavigationStyles}
`

export const HeroLink = styled.a`
  ${heroNavigationStyles}
`